export const colorPalette = [  
  '#000000',
  '#363636',
  '#4F4F4F',
  '#696969',
  '#808080',
  '#A9A9A9',
  '#D3D3D3',

  '#836FFF',
  '#483D8B',
  '#000080',
  '#0000FF',
  '#4169E1',
  '#4682B4',
  '#6495ED',
  '#1E90FF',
  '#00BFFF',
  '#87CEEB',

  '#00FFFF',
  '#00CED1',
  '#40E0D0',
  '#20B2AA',
  '#008080',
  '#7FFFD4',
  '#66CDAA',
  '#5F9EA0',

  '#2F4F4F',
  '#00FF7F',
  '#98FB98',
  '#3CB371',
  '#2E8B57',
  '#006400',
  '#228B22',
  '#00FF00',
  '#7FFF00',
  '#9ACD32',
  '#6B8E23',
  '#556B2F',

  '#BDB76B',
  '#DAA520',
  '#B8860B',
  '#8B4513',
  '#A0522D',
  '#BC8F8F',
  '#CD853F',
  '#D2691E',
  '#F4A460',
  '#FFDEAD',
  '#F5DEB3',
  '#DEB887',
  '#D2B48C',

  '#7B68EE',
  '#9370DB',
  '#8A2BE2',
  '#4B0082',
  '#9400D3',
  '#BA55D3',
  '#A020F0',
  '#FF00FF',
  '#EE82EE',
  '#DDA0DD',

  '#C71585',
  '#FF1493',
  '#FF69B4',
  '#DB7093',
  '#FFC0CB',
  '#F08080',
  '#CD5C5C',
  '#DC143C',

  '#800000',
  '#A52A2A',
  '#FA8072',
  '#FFA07A',
  '#FF6347',
  '#FF0000',

  '#FF4500',
  '#FF8C00',
  '#FFA500',

  '#FFD700',
  '#FFFF00',
  '#F0E68C',
]